import { css } from 'styled-components';
import colors from '../helpers/colors';
import fonts from '../helpers/fonts';
import mediaQuery from '../helpers/mediaQuery';
import spacing, { spacingWithBorder } from '../helpers/spacing';
import { twoLayeredBoxShadow } from './styling';

type SelectorButtonProps = {
  disabled?: boolean;
};

export const hoverStyles = css`
  background-color: transparent;
  box-shadow: inset 0 0 0 1px ${colors.core01};
  border-color: ${colors.core01};
`;

export const focusStyles = css`
  box-shadow: inset 0 0 0 1px ${colors.core01},
    ${twoLayeredBoxShadow(colors.neutral08, colors.core02)};
  border-color: ${colors.core01};
`;

export const activeStyles = css`
  background-color: ${colors.core03};
  border-color: ${colors.selectorHighlight};
`;

const borderPx = 1;

export const selectorButtonStyles = css<SelectorButtonProps>`
  padding: ${spacingWithBorder(1.75, borderPx)} ${spacing(2)};
  border-radius: ${spacing(2)};
  border: ${borderPx}px solid ${colors.neutral03};

  ${mediaQuery.tabletLandscape`
    padding: ${spacingWithBorder(2, borderPx)} ${spacing(2)};
  `}

  /* Colours and interaction */
  cursor: ${({ disabled }) => (disabled ? '' : 'pointer')};
  transition: all 0.3s ease-out;
  outline: none;

  /* Font */
  ${fonts.paragraph}
  text-align: center;
`;
